(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    class AccordionCustom extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      
      // Cerrar inmediatamente al crear el elemento
      this.closeAccordion();
    }

    connectedCallback() {
      // Verificar si debe estar abierto por defecto
      const openByDefaultDesktop = this.hasAttribute('open-by-default-on-desktop');
      const openByDefaultMobile = this.hasAttribute('open-by-default-on-mobile');
      const isMobile = window.innerWidth < 768;
      
      const shouldBeOpen = (isMobile && openByDefaultMobile) || (!isMobile && openByDefaultDesktop);
      
      if (shouldBeOpen) {
        this.details.setAttribute('open', '');
      } else {
        this.closeAccordion();
      }

      // Agregar evento de clic al summary
      this.summary.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(e) {
      const willOpen = !this.details.hasAttribute('open');
      
      if (willOpen) {
        // Si se va a abrir, cerrar todos los demás
        this.closeOtherAccordions();
      }
    }

    closeAccordion() {
      this.details.removeAttribute('open');
      this.details.open = false;
    }

    closeOtherAccordions() {
      // Buscar todos los acordeones en la página
      const allAccordions = document.querySelectorAll('accordion-custom');
      
      allAccordions.forEach(accordion => {
        if (accordion !== this) {
          const details = accordion.querySelector('details');
          if (details) {
            accordion.closeAccordion();
          }
        }
      });
    }

    disconnectedCallback() {
      this.summary.removeEventListener('click', this.handleClick);
    }
  }

  if (!customElements.get('accordion-custom')) {
    customElements.define('accordion-custom', AccordionCustom);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Script para cerrar automáticamente otras filas del acordeón
  document.addEventListener('DOMContentLoaded', function() {
    initAccordionAutoClose();
  });

  function initAccordionAutoClose() {
    const accordionGroups = document.querySelectorAll('[data-accordion-group]');
    
    accordionGroups.forEach(group => {
      const accordionRows = group.querySelectorAll('accordion-custom');
      
      accordionRows.forEach(row => {
        const details = row.querySelector('details');
        const summary = row.querySelector('summary');
        
        if (summary) {
          summary.addEventListener('click', function(e) {
            // Verificar si el acordeón se va a abrir
            const willOpen = !details.hasAttribute('open');
            
            if (willOpen) {
              // Cerrar todas las demás filas en el mismo grupo
              accordionRows.forEach(otherRow => {
                if (otherRow !== row) {
                  const otherDetails = otherRow.querySelector('details');
                  if (otherDetails && otherDetails.hasAttribute('open')) {
                    otherDetails.removeAttribute('open');
                  }
                }
              });
            }
          });
        }
      });
    });
  }

  // Reinicializar cuando se actualice el tema en el editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initAccordionAutoClose();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
